var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPpLogoDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b50073df-0842-460d-8b3b-4348dd062aee",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 422.75 43.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M78.3,5a15.11,15.11,0,0,0-15.13,15.1,17,17,0,0,0,.09,1.73,32.27,32.27,0,0,0,2.43,9.06c.5,1.22,1,2.43,1.64,3.61h0a13.64,13.64,0,0,1,21.93,0h0c.58-1.19,1.14-2.4,1.64-3.62a32.27,32.27,0,0,0,2.43-9.06c0-.59.08-1.16.08-1.73A15.1,15.1,0,0,0,78.3,5Z",
    transform: "translate(-3.67 -5.04)",
    style: {
      fill: "#1f325b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.67,9.75H17.85C24.49,9.75,29,14.62,29,21.49S24.49,33.34,17.85,33.34H12V43.89H3.67ZM16.13,26.17c2.92,0,4.35-2,4.35-4.68s-1.43-4.58-4.2-4.58H12v9.26Z",
    transform: "translate(-3.67 -5.04)",
    style: {
      fill: "#1f325b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.71,9.75H45.6c3.49,0,5.16.23,6.64.81,3.87,1.48,6.3,5,6.3,9.93,0,3.63-1.72,7.6-5.1,9.31v.1A20.53,20.53,0,0,1,54.72,32l6.64,11.94H52.05L46,32.38H42.07V43.89H33.71Zm12,15.47c2.67,0,4.35-1.48,4.35-4.2,0-1.72-.44-3-2-3.63a7.86,7.86,0,0,0-3.15-.48H42.07v8.31Z",
    transform: "translate(-3.67 -5.04)",
    style: {
      fill: "#1f325b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98,9.75h14.18c6.64,0,11.13,4.87,11.13,11.74s-4.49,11.85-11.13,11.85h-5.83V43.89H98Zm12.46,16.42c2.91,0,4.35-2,4.35-4.68s-1.44-4.58-4.2-4.58h-4.26v9.26Z",
    transform: "translate(-3.67 -5.04)",
    style: {
      fill: "#1f325b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,9.75h21.4v7.16h-13v6.21h10.41v7.16H136.4v6.45h13.7v7.16H128Z",
    transform: "translate(-3.67 -5.04)",
    style: {
      fill: "#1f325b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.2,9.75h11.89c3.48,0,5.16.23,6.64.81,3.86,1.48,6.3,5,6.3,9.93,0,3.63-1.72,7.6-5.11,9.31v.1A19.09,19.09,0,0,1,175.21,32l6.64,11.94h-9.31l-6.07-11.51h-3.92V43.89H154.2Zm12,15.47c2.68,0,4.35-1.48,4.35-4.2,0-1.72-.43-3-2-3.63a7.79,7.79,0,0,0-3.15-.48h-2.82v8.31Z",
    transform: "translate(-3.67 -5.04)",
    style: {
      fill: "#1f325b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194,16.91H183.66V9.75h29.08v7.16H202.38v27H194Z",
    transform: "translate(-3.67 -5.04)",
    style: {
      fill: "#1f325b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.38,29.9,215.11,9.75h9.5L228.48,18c1.1,2.34,2.05,4.92,2.05,4.92h.1s1-2.58,2.05-4.92l3.82-8.21H246L234.73,29.9v14h-8.35Z",
    transform: "translate(-3.67 -5.04)",
    style: {
      fill: "#1f325b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.73,9.75h14.19c6.63,0,11.13,4.87,11.13,11.74s-4.5,11.85-11.13,11.85h-5.83V43.89h-8.36ZM263.2,26.17c2.91,0,4.34-2,4.34-4.68s-1.43-4.58-4.2-4.58h-4.25v9.26Z",
    transform: "translate(-3.67 -5.04)",
    style: {
      fill: "#b4e1fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.77,9.75h21.4v7.16h-13v6.21h10.41v7.16H289.13v6.45h13.71v7.16H280.77Z",
    transform: "translate(-3.67 -5.04)",
    style: {
      fill: "#b4e1fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.7,9.17c10.6,0,17.86,7.64,17.86,17.43,0,10-7.26,17.87-17.86,17.87s-17.86-7.84-17.86-17.87C306.84,16.81,314.1,9.17,324.7,9.17Zm0,27.65c5.4,0,9.22-4.39,9.22-10.22,0-5.58-3.82-9.79-9.22-9.79s-9.22,4.21-9.22,9.79C315.48,32.43,319.3,36.82,324.7,36.82Z",
    transform: "translate(-3.67 -5.04)",
    style: {
      fill: "#b4e1fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.29,9.75h14.18c6.64,0,11.13,4.87,11.13,11.74s-4.49,11.85-11.13,11.85h-5.82V43.89h-8.36Zm12.46,16.42c2.92,0,4.35-2,4.35-4.68s-1.43-4.58-4.2-4.58h-4.25v9.26Z",
    transform: "translate(-3.67 -5.04)",
    style: {
      fill: "#b4e1fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.33,9.75h8.36v27h13.94v7.16h-22.3Z",
    transform: "translate(-3.67 -5.04)",
    style: {
      fill: "#b4e1fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.36,9.75h21.4v7.16h-13v6.21h10.41v7.16H412.72v6.45h13.7v7.16H404.36Z",
    transform: "translate(-3.67 -5.04)",
    style: {
      fill: "#b4e1fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3,14.65a6.15,6.15,0,1,0,4.35,1.81A6.13,6.13,0,0,0,78.3,14.65Z",
    transform: "translate(-3.67 -5.04)",
    style: {
      fill: "#b4e1fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.26,34.55a13.64,13.64,0,0,0-21.93,0v0a89.48,89.48,0,0,0,7.48,12.24h0a4.28,4.28,0,0,0,7,0h0a89.51,89.51,0,0,0,7.47-12.24Z",
    transform: "translate(-3.67 -5.04)",
    style: {
      fill: "#b4e1fa"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpLogoDark);
export default __webpack_public_path__ + "static/media/pp-logo-dark.72e7b730.svg";
export { ForwardRef as ReactComponent };